<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="720px">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.ruleId" class="title-actions">
        <el-button v-if="isAuth('base:docNumberRule:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:docNumberRule:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="110px">
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="单据类型" prop="docType">
            <el-select v-model="form.docType" :disabled="readonly || !!form.ruleId" filterable style="width:100%" @change="onDocTypeChange">
              <el-option v-for="item in catalog" :key="item.docType" :label="item.docName + ' (' + item.docType + ')'" :value="item.docType" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单据名称" prop="docName">
            <el-input v-model="form.docName" :disabled="readonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="生成方式" prop="genMode">
            <el-radio-group v-model="form.genMode" :disabled="readonly" @change="refreshPreview">
              <el-radio label="manual">手动输入</el-radio>
              <el-radio label="auto">自动生成</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="启用" prop="enabled">
            <el-radio-group v-model="form.enabled" :disabled="readonly">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="form.genMode === 'auto'">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="固定前缀" prop="prefix">
              <el-input v-model="form.prefix" :disabled="readonly" placeholder="如 SO" @input="refreshPreview" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="日期段" prop="datePart">
              <el-select v-model="form.datePart" :disabled="readonly" style="width:100%" @change="refreshPreview">
                <el-option label="无" value="none" />
                <el-option label="年 (yyyy)" value="yyyy" />
                <el-option label="年月 (yyyyMM)" value="yyyyMM" />
                <el-option label="年月日 (yyyyMMdd)" value="yyyyMMdd" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="流水位数" prop="serialLength">
              <el-input-number v-model="form.serialLength" :disabled="readonly" :min="1" :max="12" style="width:100%" @change="refreshPreview" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="流水重置" prop="resetCycle">
              <el-select v-model="form.resetCycle" :disabled="readonly" style="width:100%" @change="refreshPreview">
                <el-option label="不重置" value="never" />
                <el-option label="按年重置" value="year" />
                <el-option label="按月重置" value="month" />
                <el-option label="按日重置" value="day" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="编号预览">
          <el-input :value="previewCode || localPreview" readonly>
            <template slot="append">
              <el-button v-if="form.ruleId && !readonly" type="text" @click="fetchServerPreview">刷新</el-button>
            </template>
          </el-input>
        </el-form-item>
      </template>
      <el-form-item label="备注">
        <el-input v-model="form.remark" :disabled="readonly" type="textarea" :rows="2" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  data() {
    return {
      visible: false, readonly: false, catalog: [], previewCode: '', permCodes: [],
      form: this.blank(),
      rules: {
        docType: [{ required: true, message: '请选择单据类型', trigger: 'change' }],
        docName: [{ required: true, message: '单据名称不能为空', trigger: 'blur' }],
        genMode: [{ required: true, message: '请选择生成方式', trigger: 'change' }],
        prefix: [{
          validator: (rule, value, callback) => {
            if (this.form.genMode === 'auto' && !value) callback(new Error('自动编号须设置前缀'))
            else callback()
          },
          trigger: 'blur'
        }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看编号规则'
      return this.form.ruleId ? '修改编号规则' : '新增编号规则'
    },
    localPreview() {
      if (this.form.genMode !== 'auto') return ''
      const prefix = this.form.prefix || ''
      const now = new Date()
      const year = String(now.getFullYear())
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const dateMap = { none: '', yyyy: year, yyyyMM: year + month, yyyyMMdd: year + month + day }
      const len = this.form.serialLength || 4
      return prefix + (dateMap[this.form.datePart] || '') + String(1).padStart(len, '0')
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    blank() {
      return { ruleId: '', docType: '', docName: '', genMode: 'manual', prefix: '', datePart: 'yyyyMM', serialLength: 4, resetCycle: 'month', enabled: '1', sortOrder: 0, remark: '' }
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.previewCode = ''
      this.loadCatalog()
      this.form = this.blank()
      this.form.ruleId = id || ''
      this.$nextTick(() => {
        this.$refs.dataForm && this.$refs.dataForm.clearValidate()
        if (id) this.fetchDetail(id)
      })
    },
    loadCatalog() {
      request.get('/base/docNumberRule/catalog').then(res => { this.catalog = res.data || [] }).catch(() => {})
    },
    onDocTypeChange(docType) {
      const hit = (this.catalog || []).find(i => i.docType === docType)
      if (hit) this.form.docName = hit.docName
    },
    fetchDetail(id) {
      request.get('/base/docNumberRule/info/' + id).then(res => {
        Object.assign(this.form, res.data || {})
        if (this.form.genMode === 'auto') this.fetchServerPreview()
      }).catch(() => {})
    },
    refreshPreview() { this.previewCode = '' },
    fetchServerPreview() {
      if (!this.form.docType) return
      request.post('/base/docNumberRule/preview', { docType: this.form.docType }).then(res => {
        this.previewCode = (res.data && res.data.previewCode) || ''
      }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/base/docNumberRule/' + (this.form.ruleId ? 'update' : 'save'), this.form).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    remove() {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        request.post('/base/docNumberRule/delete', { ruleId: this.form.ruleId }).then(() => {
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
</style>
